/* ============
 * Application Mutations
 * ============
 *
 * The mutations available for the application module.
 */

/* eslint-disable no-param-reassign */

import {
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR,
  LOADING_START,
  LOADING_FINISH,
} from './types';

export default {

  [OPEN_SNACKBAR](state, content) {
    state.snackbar.message = content.message;
    state.snackbar.active = true;
  },

  [CLOSE_SNACKBAR](state) {
    state.snackbar.message = '';
    state.snackbar.actionText = '';
    state.snackbar.active = false;
  },

  [LOADING_START](state) {
    state.loading = true;
  },

  [LOADING_FINISH](state) {
    state.loading = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/application/mutations.js